export const autoFocusDirective = ['$timeout', $timeout => {
    return {
        restrict: 'A',
        link: function (scope, elm) {
            $timeout(function () {
                elm[0].focus();
            }, 500);
        }
    };
}];



// WEBPACK FOOTER //
// ./src/app/common/directives/auro-focus-directive.js